import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ContextResolverService } from '../../resolvers/context-resolver.service';
import { BciWkModalService } from '@bci/webkitbci';
import { GenericModalComponent } from '../../../shared/components/generic-modal/generic-modal.component';
import { FunctionType } from '../../../shared/types/function.type';

@Injectable({
  providedIn: 'root',
})
export class FunctionHandlerService {
  constructor(
    private router: Router,
    private context: ContextResolverService,
    private modal: BciWkModalService,
    private ngZone: NgZone
  ) {}

  handle(fnType: FunctionType, codigo: string, extra?: any) {
    this.functionMap[fnType]({ codigo, extra });
  }

  functionMap: { [key: string]: Function } = {
    PAGE: (data: { codigo: string; extra?: any }) =>
      this.errorPageFn(data.codigo),
    MODAL: (data: { codigo: string; extra?: any }) =>
      this.errorModalFn(data.codigo),
    NAVIGATE_IN: (data: { codigo: string; extra?: any }) =>
      this.navigateInFn({ url: data.codigo, extra: data.extra }),
    NAVIGATE_OUT: (data: { codigo: string; extra?: any }) =>
      this.navigateOutFn(data.codigo),
  };

  errorPageFn(codigo: string) {
    const url = `${this.context.context$.getValue()}/error`;
    this.ngZone.run(() =>
      this.router.navigate([url], {
        queryParams: { errorCode: codigo },
      })
    );
  }

  errorModalFn(codigo: string): void {
    this.modal.open(GenericModalComponent, codigo);
  }

  /*  Usar siempre esta funcion para navegar de forma interna a la aplicacion
      ya que se aplica el contexto en el que se encuentra el usuario */
  navigateInFn(data: { url: string; extra?: any }): void {
    const context = this.context.context$.getValue();
    this.ngZone.run(() =>
      this.router.navigate([`${context}/${data.url}`], {
        state: {data: data.extra},
      })
    );
  }

  navigateOutFn(url: string): void {
    this.ngZone.run(() => (window.location.href = url));
  }
}
